/**
 * Feature Flag Service
 *
 * Wraps `GET /api/feature-flags` with useApiFetch for consistent base URL, Capacitor bearer
 * auth, retries, and error handling. Used by the feature flags store.
 */

import type { GetFeatureFlagsResponse } from '~~/layers/base/server/api/feature-flags.get'
import { useApiFetch } from '@/composables/useApiFetch'

export const useFeatureFlagService = () => {
    /**
     * Resolve all feature flags for the current caller. Works signed-in or not — the server
     * decides identity from the session, so nothing is passed from here.
     * @returns Promise with { data: { flags }, error, pending, refresh }
     */
    const doFetchFeatureFlags = async () => {
        return useApiFetch<GetFeatureFlagsResponse>('/api/feature-flags', {
            method: 'GET',
        })
    }

    return { doFetchFeatureFlags }
}
